// extracted by mini-css-extract-plugin
module.exports = {"trDangerBg":"TableErros_trDangerBg__9etch","trPrimaryBg":"TableErros_trPrimaryBg__15AGq","trDefaultBg":"TableErros_trDefaultBg__3vZcw"};